import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderInvoiceModal } from '@/types/modal';
import { useOrderInvoice } from '@/hooks/order';
import { ErrorModal, LoadingModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: OrderInvoiceModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { order, onClose } = modal;

  const detailR = useOrderInvoice(Number(order.orderId), Number(order.buyerId), modal.isLitigation);

  useEffect(() => {
    if (detailR.kind === 'Loaded' && detailR.data.link) {
      window.open(detailR.data.link, '_blank');
      onClose();
    }
  }, [detailR.kind]);

  if (detailR.kind === 'Called') {
    return (
      <LoadingModal
        title={t('modal.order_invoice.title')}
        onClose={onClose}
      />
    );
  }
  if (detailR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.order_invoice.title')}
        error={detailR.error}
        onClose={onClose}
      />
    );
  }

  return <></>;
};

export default View;
